import { Header } from '../../components/Header/Header';
import React from 'react';
import { LoginRedirectToHAT } from '../../components/Login/Login/LoginRedirectToHAT';
import { Login } from '../../components/Login/Login/Login';

type Props = {
  path?: string;
};

export const LoginPage: React.FC<Props> = () => {
  return (
    <>
      <div className={'hatters-flex-header-column-container'}>
        <Header loginBtn={false} signupBtn={true} />
        <LoginRedirectToHAT>
          <Login />
        </LoginRedirectToHAT>
      </div>
    </>
  );
};
